// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"AllCourses_displayArea__3EKC5","allCourses":"AllCourses_allCourses__3L-0d","addCourse":"AllCourses_addCourse__1WJEl"};